import { zodResolver } from '@hookform/resolvers/zod';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import * as z from 'zod';
import useAddSpaceMember from '../../api/useAddSpaceMember';

const formSchema = z.object({
  firstName: z.string().min(1, 'Ce champ est obligatoire'),
  lastName: z.string().min(1, 'Ce champ est obligatoire'),
  email: z.string().min(1, 'Ce champ est obligatoire').email('Format incorrect'),
  role: z.enum(['admin', 'board_member', 'reader']),
});

type FormValues = z.input<typeof formSchema>;
type FormValuesOutput = z.infer<typeof formSchema>;

type Props = {
  spaceId: string;
  onClose: () => void;
};

export default function useAddMemberModal(props: Props) {
  const addMember = useAddSpaceMember();
  const [serverError, setServerError] = useState<string | null>(null);

  const form = useForm<FormValues, unknown, FormValuesOutput>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      firstName: '',
      lastName: '',
      email: '',
      role: 'reader',
    },
  });

  async function handleSubmit(data: FormValuesOutput) {
    setServerError(null);

    try {
      await addMember.mutateAsync({
        spaceId: props.spaceId,
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.email,
        role: data.role,
      });
      props.onClose();
    } catch (err) {
      setServerError(err instanceof Error ? err.message : 'Une erreur est survenue');
    }
  }

  return {
    form,
    onSubmit: form.handleSubmit(handleSubmit),
    isSubmitting: addMember.isPending,
    serverError,
  };
}
